import { useState } from 'react'
import { Card } from '@components/v2/card'
import { Loader } from '@components/v2/loader'
import { Tooltip } from '@components/tooltip/tooltip'
import { InformationCircle } from './informationCircle'
import { TOOLTIP_INFO } from '../constants'
import { t } from '@lingui/core/macro'

export const SubmissionsChartCard = ({ submissionsData, isLoading }) => {
  const [activeChart, setActiveChart] = useState('all')

  const { data, totalComplete = 0, totalErrors = 0 } = submissionsData

  return (
    <Card variant="primary">
      <Card.Header className="flex pl-[20px] justify-between border-b border-b-cv-blue-200">
        <div className="flex items-center gap-3">
          <Card.Title className="text-cv-blue-700 text-base font-bold">{t`User submissions`}</Card.Title>
          <Tooltip
            title={<p className="text-sm font-bold">{TOOLTIP_INFO.SUBMISSIONS.TITLE}</p>}
            description={<span className="text-xs">{TOOLTIP_INFO.SUBMISSIONS.DESCRIPTION}</span>}
            mode="dark"
            className="w-[343px] p-[16px]"
          >
            <InformationCircle />
          </Tooltip>
        </div>
        <div className="flex">
          {[
            { key: 'all', label: 'ALL', count: totalComplete + totalErrors },
            { key: 'complete', label: 'Complete', count: totalComplete },
            { key: 'errors', label: 'Errors', count: totalErrors },
          ].map(chart => (
            <Card.HeaderButton
              active={activeChart === chart.key}
              onClick={() => {
                setActiveChart(chart.key)
              }}
              label={chart.label}
              isLoading={isLoading}
              count={chart.count}
              key={chart.key}
            />
          ))}
        </div>
      </Card.Header>
      <Card.Content>
        {isLoading ? (
          <div className="flex justify-center items-center p-6 h-[200px]">
            <Loader className="h-12 w-12" />
          </div>
        ) : (
          <Card.Chart
            config={{
              complete: {
                label: 'Complete',
                color: 'var(--clvn-green-400)',
              },
              errors: {
                label: 'Errors',
                color: 'var(--clvn-red-200)',
              },
            }}
            data={data}
            activeChart={activeChart}
          />
        )}
      </Card.Content>
    </Card>
  )
}
